<template>
  <div>
    <card shadow>
      {{ $t('pleasechoose') }}
      <br /><br />
      <div v-for="aCase in casesInCurrentLocale" :key="aCase.case">
        <base-checkbox class="mb-3" v-model="selectedCases[aCase.case_number]">
          {{ aCase.case_number }} {{ aCase.self_evaluation_question }}
        </base-checkbox>
      </div>
    </card>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { getCases, cloneScenario } from "../services/APIService";

export default {
  data() {
    return {
      allCases: [],
      selectedCases: [],
    };
  },
  watch: {
    scenario: {
      handler(newData, oldData) {
        this.updateCases();
      },
    },
  },
  props: ["scenario", "locale"],
  computed: {
    casesInCurrentLocale() {
      return this.allCases.filter(
        (aCase) => aCase.locale === this.locale
      );
    },
  },
  methods: {
    async cloneSimulation() {
      const customCases = [];
      let caseNumber = 1;

      for (let i = 1; i <= this.casesInCurrentLocale.length; i++) {
        if (this.selectedCases[i]) {
          const newCase = {
            caseNumber: caseNumber,
            caseId: this.casesInCurrentLocale[i - 1].case
          }
          customCases.push(newCase)
          caseNumber++;
        }
      }

      // Less than 3 cases is not allowed
      if (customCases.length < 3) {
        Swal.fire({ text: this.$t("toofewcases"), allowOutsideClick: false, confirmButtonText: this.$t("close") })
        this.$bus.$emit('games-dialog-enable-submit');

        return;
      }

      const resp = await cloneScenario(this.scenario, customCases);
      this.$bus.$emit('simulation-cloned', resp.id);
    },
    async updateCases() {
      const resp = await getCases(this.scenario);
      const unsortedCases = resp.data;

      this.allCases = unsortedCases.sort((a, b) => {
        return a.case_number - b.case_number;
      });

      const cases = this.casesInCurrentLocale;

      // let's initialize checkboxes to true
      for (let i = 0; i < cases.length; i++) {
        this.selectedCases[cases[i].case_number] = true;
      }
    },
  },
  beforeDestroy() {
    this.$bus.$off("clone-simulation");
  },  
  mounted() {
    this.$bus.$on("clone-simulation", () => {
        this.cloneSimulation();
    });

    this.updateCases();
  },
};
</script>

<i18n>
{
  "en": {
    "close": "Close",
    "toofewcases": "Minimum number of cases is three",
    "pleasechoose": "Please choose cases used in the simulation. Minimum number of cases is three."
  },
  "fi": {
    "close": "Sulje",
    "toofewcases": "Tilanteita pitää olla vähintään kolme",
    "pleasechoose": "Valitse simulaatiossa käytettävät tilanteet. Minimäärä on kolme tilannetta."
  },
 "sv": {
    "close": "Stäng",
    "toofewcases": "Minsta antal fall är tre",
    "pleasechoose": "Valitse simulaatiossa käytettävät tilanteet. Minimäärä on kolme tilannetta."
  },
 "de": {
    "close": "Schließen",
    "toofewcases": "Die Mindestanzahl der Fälle beträgt drei",
    "pleasechoose": "Bitte wählen Sie Fälle aus, die in der Simulation verwendet werden. Die Mindestanzahl der Fälle beträgt drei."
  },
  "ko": {
    "close": "닫기",
    "toofewcases": "최소 케이스 수는 3개입니다.",
    "pleasechoose": "시뮬레이션에서 사용할 주제를 선택하세요. (3개 이상)"
  }
}
</i18n>
